import { render, staticRenderFns } from "./BaseFormGroupInputTest.vue?vue&type=template&id=095068a4&"
import script from "./BaseFormGroupInputTest.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroupInputTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports